"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GetMeetingsDto = void 0;
const tslib_1 = require("tslib");
const class_transformer_1 = require("class-transformer");
const class_validator_1 = require("class-validator");
const swagger_1 = require("@nestjs/swagger");
const constants_1 = require("../../../../../../services/service-lib/src/lib/constants");
class GetMeetingsDto {
    constructor() {
        this.page = constants_1.DEFAULT_VALUES.PAGE;
        this.limit = constants_1.DEFAULT_VALUES.LIMIT;
    }
}
exports.GetMeetingsDto = GetMeetingsDto;
tslib_1.__decorate([
    (0, swagger_1.ApiPropertyOptional)({
        description: "Page number for pagination.",
        example: constants_1.DEFAULT_VALUES.PAGE,
    }),
    (0, class_transformer_1.Transform)(({ value }) => parseInt(value, 10)),
    (0, class_validator_1.IsNumber)(),
    (0, class_validator_1.Min)(1, { message: "Page must be atleast 1" }),
    tslib_1.__metadata("design:type", Number)
], GetMeetingsDto.prototype, "page", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiPropertyOptional)({
        description: "Number of records per page(by default limit is 10 records).",
        example: constants_1.DEFAULT_VALUES.LIMIT,
    }),
    (0, class_transformer_1.Transform)(({ value }) => parseInt(value, 10)),
    (0, class_validator_1.IsNumber)(),
    (0, class_validator_1.Min)(1, { message: "Limit must be atleast 1" }),
    tslib_1.__metadata("design:type", Number)
], GetMeetingsDto.prototype, "limit", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiPropertyOptional)({
        description: "Search term to filter meetings.",
        example: "companyName:Example",
    }),
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsString)(),
    tslib_1.__metadata("design:type", String)
], GetMeetingsDto.prototype, "search", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiPropertyOptional)({
        description: "Sort order in the format field:order (e.g., companyName:ASC,createdAt:DESC).",
        example: "createdAt:DESC",
    }),
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsString)(),
    tslib_1.__metadata("design:type", String)
], GetMeetingsDto.prototype, "sort", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiPropertyOptional)({
        description: "Field to search by (e.g., companyName).",
        example: "Example",
    }),
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsString)(),
    tslib_1.__metadata("design:type", String)
], GetMeetingsDto.prototype, "searchBy", void 0);
